import React from 'react';
import {showPopup} from 'app/utils/modals/ModalsService';
import {modalsStore} from 'app/store/global';
import CasinoMobileSheet from 'app/components/pages/casino/CasinoMobileSheet';

type CloseSheetHandler = () => void;

type OpenCasinoMobileSheetPopupParams = {
    onAfterRowSelect?: () => void;
    renderRows: (closeSheet: CloseSheetHandler) => React.ReactNode;
    title: string;
};

export const openCasinoMobileSheetPopup = (params: OpenCasinoMobileSheetPopupParams): void => {
    const {onAfterRowSelect, renderRows, title} = params;
    const popupId = 'popup-casino-mobile-sheet';

    const closeSheet = (): void => {
        onAfterRowSelect?.();
        modalsStore.hideModal(popupId);
    };

    showPopup(
        popupId,
        (props: {popupId: string}): React.ReactElement => <CasinoMobileSheet
            popupId={props.popupId}
            title={title}
        >
            {renderRows(closeSheet)}
        </CasinoMobileSheet>
    );
};
